import { render } from "./ListeSecteur.vue?vue&type=template&id=752ecf5f&ts=true"
import script from "./ListeSecteur.vue?vue&type=script&lang=ts"
export * from "./ListeSecteur.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__